<mat-dialog-content>
    <div class="alert alert-success alert-dismissible fade show mb-0" role="alert">
         <i class="fa fa-check-circle" title="primary" aria-hidden="true" title="primary"></i>
           <!-- <i class="fa fa-info-circle" title="info" aria-hidden="true" title="success"></i> -->
           <!-- <i class="fas fa-exclamation-triangle" aria-hidden="true" title="warning"></i> -->
          {{message}}
          <button type="button" mat-dialog-close  class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true" class="close-icon">&times;</span>
          </button>
      </div>
</mat-dialog-content>
